import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cat-list mt-8 ml-8 draglist" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = ["onDragstart"]
const _hoisted_4 = ["onDrop"]
const _hoisted_5 = { class: "cat-list" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = ["onDragstart"]
const _hoisted_8 = ["onDrop"]
const _hoisted_9 = { class: "cat-list" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = ["onDragstart"]
const _hoisted_12 = { key: 0 }

import SortItems from '@/components/common/SortItems.vue';
import { Category } from '@/models/category.model';
import { ShiftCMSState } from '@/store';
import { CategoriesActions, CategoriesState } from '@/stores/categories.store';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryHierarchyForm',
  setup(__props) {

const store = useStore<ShiftCMSState & { cs: CategoriesState }>();
const categories = computed<Category[]>(() => store.state.cs.categories);

const drag = ref<boolean>(false);
const dragItem = ref<Category | null>(null);

const dragStart = (e: Event, el: Category) => {
  e.stopPropagation();
  drag.value = true;
  dragItem.value = el;

  return null;
};

const dragEnd = () => {
  drag.value = false;
  return null;
};

const dragDrop = async (evt: DragEvent, el: Category | null) => {
  evt.preventDefault();
  drag.value = false;

  await store.dispatch(CategoriesActions.UpdateCategory, {
    ...dragItem.value,
    parentCategory: el,
  });

  await store.dispatch(CategoriesActions.GetCategories);

  dragItem.value = null;
};

const dragOver = (evt: DragEvent) => {
  evt.preventDefault();

  if (evt.target) {
    (evt.target as Element).classList.add('drag-active');
  }
};
const dragLeave = (evt: DragEvent) => {
  evt.preventDefault();
  if (evt.target) {
    (evt.target as Element).classList.remove('drag-active');
  }
};

const updateSorting = async (ids: number[]) => {
  await store.dispatch(CategoriesActions.UpdateCategoriesOrder, ids);
};

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[9] || (_cache[9] = _createElementVNode("h2", null, "Edit category hierarchy", -1)),
      _createVNode(_component_v_alert, { type: "info" }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" Drag the category onto their parent. This is allowed only for "),
          _createElementVNode("i", null, "two levels", -1),
          _createTextVNode(". ")
        ])),
        _: 1
      }),
      _createVNode(_component_v_card, { class: "mt-4 pb-4" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value
            .filter((c) => !c.parentCategory)
            .sort((a, b) => a.index - b.index), (cat) => {
              return (_openBlock(), _createElementBlock("li", {
                key: cat.id
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", {
                    class: "name",
                    draggable: "true",
                    onDragstart: (e) => dragStart(e, cat),
                    onDragend: dragEnd
                  }, _toDisplayString(cat.title), 41, _hoisted_3),
                  (drag.value && dragItem.value?.id !== cat.id)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "drop-target",
                        onDrop: (e) => dragDrop(e, cat),
                        onDragover: _cache[0] || (_cache[0] = (e) => dragOver(e)),
                        onDragleave: _cache[1] || (_cache[1] = (e) => dragLeave(e))
                      }, null, 40, _hoisted_4))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value
                .filter((c) => c.parentCategory?.id === cat.id)
                .sort((a, b) => a.index - b.index), (cat2) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: cat2.id
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", {
                          class: "name",
                          draggable: "true",
                          onDragstart: (e) => dragStart(e, cat2),
                          onDragend: dragEnd
                        }, _toDisplayString(cat2.title), 41, _hoisted_7),
                        (drag.value && dragItem.value?.id !== cat2.id)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "drop-target",
                              onDrop: (e) => dragDrop(e, cat2),
                              onDragover: _cache[2] || (_cache[2] = (e) => dragOver(e)),
                              onDragleave: _cache[3] || (_cache[3] = (e) => dragLeave(e))
                            }, null, 40, _hoisted_8))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value
                    .filter((c) => c.parentCategory?.id === cat2.id)
                    .sort((a, b) => a.index - b.index), (cat3) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: cat3.id
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", {
                                class: "name",
                                draggable: "true",
                                onDragstart: (e) => dragStart(e, cat3),
                                onDragend: dragEnd
                              }, _toDisplayString(cat3.title), 41, _hoisted_11)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128)),
            (drag.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "drop-target",
                    onDrop: _cache[4] || (_cache[4] = (e) => dragDrop(e, null)),
                    onDragover: _cache[5] || (_cache[5] = (e) => dragOver(e)),
                    onDragleave: _cache[6] || (_cache[6] = (e) => dragLeave(e))
                  }, null, 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "mt-8" }, "Sort categories", -1)),
      _createVNode(SortItems, {
        items: categories.value.sort((a, b) => a.index - b.index),
        onChange: updateSorting
      }, null, 8, ["items"]),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { col: "2" }),
          _createVNode(_component_v_col),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                class: "mt-2",
                type: "reset",
                block: ""
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Close")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { col: "2" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})